module.exports = __webpack_public_path__ + "static/media/notification-off.7fc65a3b.svg";